module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "picture"
  }, [_c('div', {
    staticClass: "picture__holder"
  }, [_c('div', {
    staticClass: "picture__data"
  }, [_c('img', {
    staticClass: "picture__img",
    class: {
      'picture__img_copp': _vm.copp
    },
    attrs: {
      "src": _vm.src,
      "alt": _vm.alt
    }
  }), (_vm.finished) ? _c('div', {
    staticClass: "picture__finished"
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-410e3441","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/components/picture/Picture.vue
// module id = cdeb62e02cf236844b78
// module chunks = 89